"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mask = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Mask = function Mask() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.65 8.16a6.69 6.69 0 012 .84.5.5 0 01.06.83l-.73.73a.51.51 0 01-.61.07 5.598 5.598 0 00-1-.44l-.37-.08v3.93a2 2 0 01-2 2h-3.9c.08.12.08.25.08.37.114.347.261.682.44 1a.51.51 0 01-.07.61l-.73.73a.5.5 0 01-.79-.11 6.69 6.69 0 01-.84-2l-.018-.074c-.045-.187-.092-.38-.092-.566H4a2 2 0 01-2-2V4a2 2 0 012-2h10.01a2 2 0 012 2v4.05c.08.011.161.03.243.049.133.03.267.061.397.061zM14 4H4v10h4a6.91 6.91 0 011-2.65 7.08 7.08 0 012.35-2.27 6.91 6.91 0 012.65-1V4zm7.32 12h-1a.5.5 0 00-.48.38 5.598 5.598 0 01-.44 1 .51.51 0 00.07.61l.73.73a.5.5 0 00.79-.11 6.69 6.69 0 00.84-2 .5.5 0 00-.51-.61zm-8.7 3.37c.318.179.653.326 1 .44a.5.5 0 01.4.51v1a.5.5 0 01-.63.48 6.69 6.69 0 01-2-.84.5.5 0 01-.11-.79l.73-.73a.51.51 0 01.61-.07zm7.19-5.75a.5.5 0 00.48.38h1a.5.5 0 00.48-.63 6.69 6.69 0 00-.84-2 .5.5 0 00-.79-.11l-.73.73a.51.51 0 00-.07.61c.19.323.348.665.47 1.02zm-2.42 5.75a.51.51 0 01.61.07l.75.7a.5.5 0 01-.11.79 6.69 6.69 0 01-2 .84.5.5 0 01-.63-.48v-1a.5.5 0 01.38-.48 5.598 5.598 0 001-.44z",
    clipRule: "evenodd"
  });
};

exports.Mask = Mask;